import { Routes } from '@angular/router';
import { provideAppNgxMask } from 'app/ngx-mask.config';
import { caseCreateSuccessResolver } from './features/case-creation/case-create-success/case-create-success.resolver';
import { caseCreationOptionsResolver } from './features/case-creation/case-creation-options.resolver';

export const CASE_CREATION_PATH = 'case-anlegen';
export const CASE_CREATE_SUCCESS_PATH = 'cases/:caseId/angelegt';
export const ERROR_PATH = 'fehler';

export const routes: Routes = [
  {
    path: '',
    title: 'eazi Portal',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: CASE_CREATION_PATH,
    title: 'Case anlegen',
    resolve: { options: caseCreationOptionsResolver },
    providers: [provideAppNgxMask()],
    loadComponent: () =>
      import('./features/case-creation/case-create/case-create.component').then((m) => m.CaseCreateComponent),
  },
  {
    path: CASE_CREATE_SUCCESS_PATH,
    title: 'Case angelegt',
    resolve: { caseCreateSuccess: caseCreateSuccessResolver },
    loadComponent: () =>
      import('./features/case-creation/case-create-success/case-create-success.component').then(
        (m) => m.CaseCreateSuccessComponent,
      ),
  },
  {
    path: ERROR_PATH,
    title: 'Fehler',
    loadComponent: () => import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
